import i18nextInstance from 'i18next';


let routes = {};

i18nextInstance.on('initialized', () => {
  routes = {
    en: {
      landing: '/',
      quiz:'/questions',
      results: '/results',
    },
    cy: {
      landing: '/',
      quiz:'/cwestiynau',
      results: '/canlyniadau',
    }
  };
});

export function route(name, parameters = null, language = i18nextInstance.language) {
  if (parameters) {
    return routes[language][name]
      .split('/')
      .map((fragment) => {
        return fragment.startsWith(':') ? parameters[fragment.substr(1)] : fragment;
      })
      .join('/');
  }

  return routes[language][name];
}

export function routeTranslated(name, parameters) {
  return route(name, parameters, i18nextInstance.language === 'en' ? 'cy' : 'en');
};